{
  "accountInformation": "Account Information",
  "accountStatus": "Account Status",
  "active": "Active",
  "admin": "Administrator",
  "adminBadge": "Admin",
  "adminPrivileges": "Administrator Privileges",
  "aiDefaultHelp": "How can I help you today?",
  "aiDepositHelp": "Ask about deposit issues, delays or confirmations.",
  "aiKycHelp": "Ask about KYC verification and document requirements.",
  "aiLoginHelp": "Ask about login, password or account access issues.",
  "aiP2pHelp": "Ask about P2P orders, disputes or payment issues.",
  "aiSupportAssistant": "AI Support Assistant",
  "aiSupportAssistantText": "Get instant answers to common questions, or create a ticket for our team.",
  "aiWithdrawHelp": "Ask about withdrawal status, delays or requirements.",
  "askAiSupport": "Ask AI Support",
  "bio": "Professional Bio",
  "capital": "Capital",
  "changeImage": "Change Image",
  "cnicBack": "ID Card (Back)",
  "cnicFront": "ID Card (Front)",
  "connectedWallet": "Connected Wallet",
  "country": "Country",
  "createSupportTicket": "Create Support Ticket",
  "describeIssue": "Describe your issue",
  "disabled": "Disabled",
  "displayName": "Display Name",
  "editProfile": "Edit Profile",
  "email": "Email",
  "emailOtpSendFailed": "Failed to send verification code. Please try again.",
  "emailOtpSent": "Verification code sent to your email.",
  "emailVerification": "Email Verification",
  "emailVerifiedSuccessfully": "Email verified successfully.",
  "enabled": "Enabled",
  "enterEmailOtp": "Enter verification code",
  "enterOtpFirst": "Please enter the verification code first.",
  "estimatedProfit": "Estimated Profit",
  "faceVerificationNotAutomated": "Automated face verification is not available yet. Your uploaded selfie will be reviewed manually as part of KYC approval.",
  "failedLoadNotifications": "Failed to load notifications.",
  "failedMarkAllRead": "Failed to mark all as read.",
  "failedMarkRead": "Failed to mark as read.",
  "failedSubmitTicket": "Failed to submit ticket.",
  "fullLegalName": "Full Legal Name",
  "fullName": "Full Name",
  "idNumber": "ID Number",
  "imagePreview": "Image Preview",
  "imageTooLarge": "Maximum image size is 5 MB.",
  "inactive": "Inactive",
  "invalidImageType": "Only JPG, PNG and WEBP images are allowed.",
  "invalidOtp": "Invalid or expired code. Please try again.",
  "joinedDate": "Joined Date",
  "kycStatus": "KYC Status",
  "kycSubmissionFailed": "KYC submission failed.",
  "kycSubmittedSuccessfully": "KYC submitted successfully.",
  "lastLogin": "Last Login",
  "liquidationZone": "Liquidation Zone",
  "loadingNotifications": "Loading notifications...",
  "loadingProfile": "Loading profile...",
  "markAllRead": "Mark All as Read",
  "mobileNumberCountryCode": "Mobile Number (with Country Code)",
  "network": "Network",
  "noNotifications": "No notifications yet.",
  "noUtilityToolsFound": "No utility tools found.",
  "notSubmitted": "Not Submitted",
  "notVerifiedEmail": "Not Verified",
  "openTool": "Open Tool",
  "owner": "Owner",
  "ownerBadge": "Owner",
  "ownerControlCenter": "Owner Control Center",
  "passportNationalId": "Passport / National ID",
  "pending": "Pending",
  "phoneNumber": "Phone Number",
  "positionSize": "Position Size",
  "positionValue": "Position Value",
  "processing": "Processing...",
  "profileImage": "Profile Image",
  "profileSecurity": "Profile Security",
  "profileSubtitle": "Manage your account profile, security, identity and personal information.",
  "profileTitle": "Profile",
  "profileUpdateFailed": "Profile update failed.",
  "profileUpdatedSuccessfully": "Profile updated successfully.",
  "read": "Read",
  "rejected": "Rejected",
  "removeImage": "Remove Image",
  "required": "Required",
  "riskAmount": "Risk Amount",
  "riskPercent": "Risk Percent",
  "riskPositionCalculator": "Risk & Position Calculator",
  "role": "Role",
  "saveProfile": "Save Profile",
  "savingProfile": "Saving Profile...",
  "securityLevel": "Security Level",
  "selfieVerification": "Selfie Verification",
  "sendEmailOtp": "Send Email OTP",
  "sendingEmailOtp": "Sending...",
  "serverError": "Server error.",
  "sessionActive": "Session Active",
  "sessionExpired": "Session expired. Please login again.",
  "subject": "Subject",
  "submitKyc": "Submit KYC",
  "submitTicket": "Submit Ticket",
  "submittingKyc": "Submitting KYC...",
  "supportBadge": "Support",
  "supportRequiredFields": "Subject and description are required.",
  "telegram": "Telegram Username",
  "ticketSubmittedSuccessfully": "Ticket submitted successfully.",
  "tools": "Tools",
  "totalNotifications": "Total Notifications",
  "twoFactorStatus": "Two-Factor Authentication",
  "uid": "UID",
  "unread": "Unread",
  "updateSuccessful": "Profile updated successfully.",
  "uploadBackSide": "Upload Back Side",
  "uploadDocument": "Upload Document",
  "uploadFrontSide": "Upload Front Side",
  "uploadIdDocument": "Please upload an ID document.",
  "uploadImage": "Upload Image",
  "uploadSelfie": "Upload Selfie",
  "uploadSelfieRequired": "Please upload a selfie photo before submitting.",
  "user": "User",
  "userId": "User ID",
  "userProfile": "User Profile",
  "utilityTools": "Utility Tools",
  "verified": "Verified",
  "verifiedBadge": "Verified",
  "verifiedEmail": "Verified",
  "verifyEmailFirst": "Please verify your email first.",
  "verifyingEmailOtp": "Verifying...",
  "walletAddress": "Wallet Address",
  "walletOrderTxOptional": "Wallet address, order ID or transaction ID (optional)",
  "writeProfessionalBio": "Write a professional introduction about yourself."
}